
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"_x35_7282e78-92e5-4872-a77c-e84915b15d8e","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 80 80","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.5 21h53c3.3 0 6 2.7 6 6v26c0 3.3-2.7 6-6 6h-53c-3.3 0-6-2.7-6-6V27c0-3.3 2.7-6 6-6z","fill":"#0078a9"}}),_c('path',{staticClass:"st1",attrs:{"d":"M39 34.2l-3.4 7.9-3.7-7.9h-4.4v11l-4.8-11h-4.1l-5 11.6h3l1-2.5h5.9l1 2.5h5.7v-9.1l4.1 9.1h2.4l4.1-9.1v9.1h2.8V34.2H39zm-20.3 6.6l1.9-4.6 1.9 4.6h-3.8zM60.9 40l5.4-5.8h-3.6L59.1 38l-3.4-3.8H44.6v11.6h11l3.5-3.8 3.4 3.8h3.8L60.9 40zm-6.7 3.4h-6.9v-2.3h6.1v-2.3h-6.1v-2.1h7l3 3.4-3.1 3.3z","fill":"#fff"}}),_c('path',{attrs:{"d":"M0 0h80v80H0V0z","fill":"none"}})])
          )
        }
      }
    